
import { createMachine, assign, actions } from 'xstate';

//const { raise } = actions;

const SUBCRIBE_MSG_PERIOD = 20;
export const coinMachine = createMachine({
    /** @xstate-layout N4IgpgJg5mDOIC5QGED2BLAdgZQC4ENcwBZfAYwAsswA6LdXdfAGz0LAGIAPWAom-ADMiAJwAUAVgAMUgJQc0WNkVKVqdTAyas+YANpSAuolAAHVLC2pMJkF0QA2AMxOaADgCMAJgAsATg8PNy8AgHZQgBoQAE9ELykPGlD-Pz8HDx8JHx83JwBfPKjFHF1VKkxaACVUXWLuXnYBYTBxJzkFDBL2MvVq2s6DYyQQc0tGa1t7BCko2OmCos7lEnJyqpr2Op5dJtExNvbi5Z6Kmj7NgaNbUasbYamAWglXJ1DAqUzPJy8nBz9ZxAeV40HwOUJ+HxOPxeBzSKQOBYgI6lVa9DZELYNfhCPYHeTI7qo07nDEDDxDMwWW6TRAzGK0xEElRE2jYCioADupC4AHUsPUdjiWpIZIclii1Kc2ZzuXzMINrlTxndQFNnK5PL4AkEQh5wgCEDCpDQvHD4VIJH5PGlGeLCZLWeyOQAJBiwAWNIXiM34u3Mh00aUut0K4Y3ZU0hDq9zefyBYJhSL0hBOIJJOESEJuKS+SG2pQStY0Hn4Bge7HNcQeGS+gv2oslhihyljdATe60g1SAqFECYVAQOC2JkrB2K1vt1WIB7VxKvd6fIE-P4Gh5uUIg1Jb6ShWHw-K9kcnWj0RgsZbj6kdhDSLw0DJuHxvaFeN4OLwG+LG5Jb1-g0GWvmXT+kWJJgMUl4Rte6Q0FIoRSG0oQwq+j4fJ+LgmnCgTOA4bi4RIEhAccLKBk6spYJBbYqnYiA5MaDhSH4Ti3kEoSPhIn6WiaKR+Jm0LvrCRGFuoQaurg8BhkqVGRv4rhwT4HhWpmbS8R+yaphuoRwq+CnwlmhGHn6o4NqWuCUZONEIGxfjuJCoS-M8EhuH48IGm4Eg0A4PFuJ4mRtIBPZAA */
    id: 'CoinStateMachine',

    context: {
        subscribeMsgInterval:0,
        frame: 0,
        tick: 0,
        interval: 0.05,
        frameCounts: 9,
        isExternalWin: false,
        coinStateCount: 3,
        nextState: 0,
        isSubscribed: true,
        startClickX: 0,
        startClickY: 0,
        offSetX: 0,
        offSetY: 0
    },
    initial: 'Normal',
    predictableActionArguments: true,

    on: {
        // SUBSCRIBED: {
        //     actions: [assign({ isSubscribed: true })]
        // },
        // UNSUBSCRIBED: {
        //     actions: [assign({ isSubscribed: false })],
        //     internal: true,
        // },
        // COMMERCIAL: {
        //     actions: [assign({ casinoCategory: "commercial" })],
        //     internal: true,
        // },

        // SOCIAL: {
        //     actions: [assign({ casinoCategory: "social" })],
        //     internal: true,
        // },

        IS_COIN_CLICKED: {
            actions: [assign({ isCoinClicked: true, subscribeMsgInterval:0, showSubscribeMsg:false }),(ctx)=>{
            //actions: [assign({ isCoinClicked: false,  subscribeMsgInterval:0 }),(ctx)=>{
                //console.log("isCoinClicked: "+ctx.isCoinClicked+" | SUBCRIBE_MSG_PERIOD: " +SUBCRIBE_MSG_PERIOD)
            }
            ],
            internal: true,
        },




    },

    states: {


        Normal: {

            on: {
                mousedown: {
                    actions: ["beforeDragging"],
                    target: "Drag.MouseDown"
                },

            },

            states: {
                RotateCoin: {

                    entry: (context) => {
                        //console.log("ROTATE_COIN | CoinState: ... " + context.coinStateCount)
                        //console.log("ROTATE_COIN | context.isSubscribed " + context.isSubscribed)



                        // if (context.showSubscribeMsg){
                        //     return false
                        // }    


                        // if (!context.isCoinClicked)
                        //     if (!context.isSubscribed) {
                        //         //context.even = !context.even
                        //         if (context.subscribeMsgInterval>SUBCRIBE_MSG_PERIOD){
                        //             context.subscribeMsgInterval = 0
                        //         }
                                
                        //         if (context.subscribeMsgInterval===SUBCRIBE_MSG_PERIOD){
                        //             return
                        //         }

                        //         // if (context.even) {
                        //         //     return
                        //         // }
                        //     }



                        context.nextState++
                        if (context.nextState > context.coinStateCount) context.nextState = 0

                        context.frame = 0
                        context.tick = 0
                    },

                    exit: (context) => {
                        context.tick = 0;
                        context.frame = 0

                    },

                    invoke: {
                        src: (context) => (cb) => {
                            const interval = setInterval(() => {
                                cb('TICK');
                            }, 1000 * context.interval);

                            return () => {
                                clearInterval(interval);


                            };
                        }
                    },
                    on: {
                        '': [
                            // {
                            //     target: 'SubscriptionPopup',
                            //     cond: (context) => {
                            //         return context.showSubscribeMsg
                                    
                            //     },
                            // },

                            {
                                target: 'ShowMaxWin',
                                cond: (context) => {
                                    return context.tick > context.frameCounts && context.nextState === 0;

                                }
                            },
                            {
                                target: 'ShowHits',
                                cond: (context) => {
                                    return context.tick > context.frameCounts && context.nextState === 1;
                                },
                            },

                            {
                                target: 'ExternalWin',
                                cond: (context) => {
                                    return context.tick > context.frameCounts && context.nextState === 2;
                                },
                            },


                            {
                                target: 'DragAndDropHint',
                                cond: (context) => {
                                    return context.tick > context.frameCounts && context.nextState === 3;
                                },
                            },



                        ],
                        TICK: {
                            actions: assign({
                                frame: (context) => {
                                    context.tick++;
                        //console.log("TICK: .isCoinClicked: "+context.isCoinClicked+" | isSubscribed"+context.isSubscribed+" | subscribeMsgInterval: "+context.subscribeMsgInterval)          
                        //if (!context.showSubscribeMsg )
                            if (!context.isCoinClicked)
                             if (!context.isSubscribed) {
                                 context.subscribeMsgInterval++;
                                 if (context.subscribeMsgInterval>SUBCRIBE_MSG_PERIOD){
                                    //context.subscribeMsgInterval = 0
                                    context.showSubscribeMsg = true
                                 }

                             }



                                    return context.tick <= context.frameCounts ? context.tick : 0
                                }
                            })
                        }
                    }

                },

                ShowMaxWin: {

                    after: {
                        "5000": "RotateCoin"
                    }
                },

                ShowHits: {
                    after: {
                        "5000": "RotateCoin"
                    }
                },

                SubscriptionPopup: {
                    entry: [(context)=>{
                        context.showSubscribeMsg = false
                        context.subscribeMsgInterval = 0}],
                    after: {
                        "2000": "RotateCoin"
                    },

                    on: {
                        subscriptionPopupClick: {
                            actions: [(context) => {
                                console.log("context.subscribeMsgInterval: "+context.subscribeMsgInterval)
                            }, "openMenu"],
                        },
                    },
                },

                ExternalWin: {
                    entry: ["checkExternalWin"],
                    exit: ["removeExternalWin"],
                    after: {
                        "5000": "RotateCoin"
                    },
                },




                DragAndDropHint: {
                    after: {
                        "5000": "RotateCoin"
                    },


                }


            },
            initial: "ExternalWin"
        },

        Drag: {
            initial: "MouseOver",

            on: {
                mouseout: {
                    target: "#CoinStateMachine.Normal"
                },
            },

            states: {
                MouseOver: {
                    on: {
                        mousedown: {
                            target: "MouseDown"
                        },
                        // mouseout: {
                        //     target: "#CoinStateMachine.Normal.RotateCoin"
                        // },


                    }

                },

                Drop: {
                    // entry: [(context) => {


                    // }],
                    always: [{ target: "#CoinStateMachine.Normal" }]

                },
                MouseDown: {
                    entry: [(context) => {
                        context.tick = 0;
                        context.nextState = 0
                        context.frame = 0
                        context.tick = 0
                    }],
                    on: {
                        mousemove: {
                            actions: ["startDragging"],
                            cond: (context, event) => {
                                let distance = Math.hypot(
                                    context.startClickX - event.pos.x,
                                    context.startClickY - event.pos.y
                                );

                                return distance > 1;
                            },
                            target: "Dragging"


                        },
                        mouseup: {
                            // window_mouseup: {
                            actions: [() => {
                                //console.log("CoinWidgetSM onmouseUp 2.5")
                            }, "openMenu"],

                            target: "#CoinStateMachine.Normal"
                        }
                    }
                },
                Dragging: {

                    entry: (context) => {
                        context.coinStateCount = 2
                    },
                    exit: "stopDragging",

                    on: {
                        window_mousemove: {
                            actions: "updateWidgetPosition"

                        },
                        window_mouseup: {
                            target: "#CoinStateMachine.Normal"
                        }
                    }
                },

            }

        },
        on: {
            userSubsribeUpdate: {
                actions: [
                    (context) => {
                        console.log("userSubsribeUpdate on Normal")
                    }]
            }
        }
    },
});


//entry: assign({ component: (ctx) => ctx.component = Login }),
